import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/userStore";
import Menu from "primevue/menu";
import Button from "primevue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMenu',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const menu = ref();

const isLoggedIn = computed(() => userStore.isLoggedIn);

const items = [
  {
    label: "예시 관리",
    icon: "pi pi-list",
    command: () => {
      router.push("/examples");
    },
  },
  {
    label: "로그아웃",
    icon: "pi pi-sign-out",
    command: async () => {
      await userStore.logout();
      router.push("/signin");
    },
  },
];

const navigateToSignIn = () => {
  router.push("/signin");
};

const toggle = (event: Event) => {
  menu.value.toggle(event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isLoggedIn.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_unref(Button), {
            type: "button",
            icon: "pi pi-user",
            class: "p-button-text p-button-rounded",
            onClick: toggle,
            "aria-haspopup": "true",
            "aria-controls": "overlay_menu",
            "aria-label": "사용자 메뉴"
          }),
          _createVNode(_unref(Menu), {
            ref_key: "menu",
            ref: menu,
            model: items,
            popup: true,
            id: "overlay_menu"
          }, null, 512)
        ], 64))
      : (_openBlock(), _createBlock(_unref(Button), {
          key: 1,
          label: "로그인",
          icon: "pi pi-sign-in",
          onClick: navigateToSignIn,
          class: "p-button-text"
        }))
  ]))
}
}

})